<template lang="pug">
  .container-outlay.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item(:to="detailURL") 营销账户详情
          el-breadcrumb-item 余额动态
    c-box
      el-form(:model="$data", label-position="right", label-width="100px")
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="操作日期")
              el-date-picker(v-model="date", type="daterange", placeholder="选择日期范围")
            el-form-item(label="流水号")
              el-input(v-model="filters.log_id")
          el-col(:span="12")
            el-form-item(label="状态")
              el-select(v-model="filters.status")
                el-option(:value="null", label="全部")
                el-option(v-for="n in 3", :key="n", :value="n", :label="n | status")
            el-form-item(label="业务类型")
              el-select(v-model="filters.rel_biz_type")
                el-option(:value="null", label="全部")
                el-option(v-for="n in 2", :key="n", :value="n", :label="n | rel_biz_type")
        el-form-item(label="")
          el-button(@click="setFilter", type="primary") 搜索
          el-button(@click="timeReset") 重置时间
          el-button(@click="clearFilter", v-show="hasFilter") 清除
      el-table(:data="list", fit, v-loading="listLoading")
        el-table-column(property="log_id", label="流水号", min-width="200", show-tooltip-when-overflow)
        el-table-column(property="act_date", label="操作时间", min-width="200", show-tooltip-when-overflow)
        el-table-column(label="充值类型", min-width="150", show-tooltip-when-overflow, v-slot="{ row }") {{ row.act_type | outlay_act_type }}
        el-table-column(label="充值金额", min-width="150", show-tooltip-when-overflow, v-slot="{ row }").
          {{ !(row.act_type === 2 || row.act_type === 3 || row.act_type === 5) ? row.amount : 0 - row.amount | toYuan }}
        el-table-column(property="operator", label="操作者", min-width="150", show-tooltip-when-overflow)
        el-table-column(label="状态", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.status | outlay_act_status }}
        el-table-column(label="操作", min-width="100", align="right", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", @click="showDetail(row)") 详情
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")

    el-dialog(title="余额动态详情", :visible.sync="detail.show")
      el-form(:model="detail.source", label-position="right", label-width="125px")
        el-form-item(label="流水号") {{ detail.source.log_id }}
        el-form-item(label="操作类型") {{ detail.source.act_type | outlay_act_type }}
        el-form-item(label="金额"). 
          {{ !(detail.source.act_type === 2 || detail.source.act_type === 3 || detail.source.act_type === 5) ?
          detail.source.amount : 0 - detail.source.amount | toYuan }}
        el-form-item(label="转账凭证")
          .img-container(v-if="detail.source.pic_array.length > 0", v-for="(p, $index) in detail.source.pic_array")
            img(:src="p | image", @click="$zoom($options.filters.image(p))").img-thumbnail
          template(v-if="detail.source.pic_array.length === 0") 未上传任何图片
        el-form-item(label="备注", v-if="!(detail.source.act_type === 3 || detail.source.act_type === 5)") {{ detail.source.remark }}
        el-form-item(label="操作者") {{ detail.source.operator }}
        el-form-item(label="操作时间") {{ detail.source.act_date }}
        el-form-item(label="应用订单号或标识") {{ detail.source.outer_bill_id }}
        el-form-item(label="状态") {{ detail.source.status | outlay_act_status }}
        el-form-item(label="驳回原因", v-if="detail.source.status === 3") {{ detail.source.reason }}
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="hideDetail()") 关闭
</template>

<script>
export default {
  data () {
    return {
      page:   1,
      size:   10,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,

      filters: {
        rel_biz_type: null,
        status:       null,
        log_id:       null,
      },
      date:       [],
      hasFilter:  false,

      detail:       {
        show:     false,
        source:   {
          pic_array:  [],
        },
      }
    };
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
    detailURL () {
      return `/outlay/${this.outlay_account_id}`;
    }
  },
  filters: {
    rel_biz_type (source) {
      switch (source) {
        case  1:  return '余额业务';
        case  2:  return '积力宝业务';
        // case  3:  return '现金券业务';
        default:  return source;
      }
    },
    status (source) {
      switch (source) {
        case  1:  return '待审核';
        case  2:  return '审核成功';
        case  3:  return '审核失败';
        default:  return source;
      }
    },
  },
  methods: {
    showDetail (row) {
      const pic_array = row.pic_urls ? row.pic_urls.split(',') : [];

      this.detail = {
        show:     true,
        source:   Object.assign({}, row, {
          pic_array
        }),
      };
    },
    hideDetail () {
      this.detail = {
        show:     false,
        source:   {
          pic_array:  [],
        },
      };
    },

    timeReset () {
      this.date = [];
      this.refresh();
    },
    setFilter () {
      if (this.filters.rel_biz_type || this.filters.status || this.filters.log_id ||
        (Array.isArray(this.date) && this.date.length === 2)) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.refresh();
    },
    clearFilter () {
      this.filters = {
        rel_biz_type: null,
        status:       null,
        log_id:       null,
      };

      this.hasFilter = false;
      this.timeReset();
      this.refresh();
    },
    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList (page = 1) {
      if (!this.outlay_account_id) {
        this.$alert('营销账户 ID 错误。', {
          type:   'error',
        }).then(() => {
          this.$router.push('/outlay');
        });
      } else if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters, {
        start_date:     (Array.isArray(this.date) && typeof this.date[0] !== 'undefined') ? this.$dateFormatter(this.date[0]) : null,
        end_date:       (Array.isArray(this.date) && typeof this.date[1] !== 'undefined') ? this.$dateFormatter(this.date[1]) : null,
      });
      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_ACTIVITY_LIST', Object.assign({}, {
        outlay_account_id: this.outlay_account_id,
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }, _filters)).then((data) => {
        this.list = data.list;
        this.total = data.total;
        return data;
      }).catch(({ code, msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    }
  },
  mounted () {
    this.getList(1);
  },
};
</script>